<template>

    <v-card
        flat
        class="d-flex flex-column fill-height"
        style="border-radius: 5px;"
    >
        <div class="fill-height" v-if="threadLoaded">
            <v-card-title style="color: #424242;" :style="((bot_details) ? 'background: ' + bot_details.widget_header_color : '')">
                <div class="w-full">
                    <div class="lf-inbox-chat-item-avatar"><i class="mdi mdi-account-outline"></i></div>

                    <div class="lf-chat-inbox-item-middle" style="padding-top: 10px;">
                        <h1 class="lf-chat-inbox-item-contact" style="line-height: 22px; font-size: 15px;" :style="((bot_details) ? 'color: ' + bot_details.widget_text_color : '') + '; margin: 0px;'">
                            {{ bot_details.company_name }}
                        </h1>
                        
                        <h2 v-if="bot_details.description" class="lf-chat-inbox-item-contact" style="line-height: 22px; font-size: 13px;" :style="((bot_details) ? 'color: ' + bot_details.widget_text_color : '') + '; margin: 0px;'">
                            {{ bot_details.description }}
                        </h2>
                    </div>

                    <div style="position: absolute; right: 10px; top: 10px;">
                        <div>
                            <button
                                class="float-right"
                                style="color: #757b89 !important; background: #FFFFFF; border: 0px; border-radius: 5px; margin-top: 14px; cursor: pointer; margin-right: 5px; height: 30px; padding-left: 4px; padding-right: 4px;"
                                @click="messages = []; getResponse();"
                                >
                                <i class="mdi mdi-refresh" style="font-size: 18px;"></i>
                            </button>

                            <button
                                v-show="!isAccelerate()"
                                class="float-right"
                                style="color: #757b89 !important; background: #FFFFFF; border: 0px; border-radius: 5px; margin-top: 14px; cursor: pointer; margin-right: 5px; height: 30px; padding-left: 4px; padding-right: 4px;"
                                @click="showPopover = !showPopover"
                                >
                                <i class="mdi mdi-microphone" style="font-size: 18px;"></i>
                            </button>

                            <!-- Popover -->
                            <div
                                v-if="showPopover"
                                class="popover"
                                :style="popoverStyle"
                                ref="popover"
                            >
                                <template v-if="!callActive">
                                <div class="option">
                                    <label>📞 Call me:</label>
                                    <input v-model="phoneNumber" type="text" placeholder="Enter phone number" style="padding: 5px;" />
                                    <button @click="callMe" class="btn btn-success mt-1">Submit</button>
                                </div>
                                <div class="option mt-5">
                                    <label>Talk in browser:</label>
                                    <button @click="startInBrowserCall" class="btn btn-secondary">🗣️ Start Call</button>
                                </div>
                                </template>

                                <template v-else>
                                <div class="call-status">
                                    <p>🔊 In-browser call is active...</p>
                                    <button @click="endInBrowserCall" class="btn btn-danger mt-1">End Call</button>
                                </div>
                                </template>
                            </div>

                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
                
            </v-card-title>

            <div id="lfp-messages-list" class="overflow-y-auto" :style="'' + (($route.query.fl) ? 'height: 350px;' : 'height: calc(100% - 180px);') + ' background: ' + bot_details.widget_box_color">

              <div v-for="(msg, i) in messages" :key="'message-' + i">
                  <div style="padding: 10px;">
                    <h3 :class="((msg.role == 'user') ? 'float-right': 'float-left')" style="color: #555555; height:auto; white-space: normal; max-width: 500px; border-radius: 16px; font-size: 14px; padding: 10px; line-height: 20px; margin: 0px;"
                      :style="((msg.role == 'user') ? 'background: ' + bot_details.widget_chat_bubble_right_color + '; color: #FFFFFF;': 'background: ' + bot_details.widget_chat_bubble_left_color + ';') + ((bot_details) ? 'color: ' + bot_details.widget_text_color + ';' : '')"
                    >
                      <div v-html="formatContent(msg.content)"></div>
                    </h3>

                    <div style="clear: both;"></div>
                  </div>
              </div>

              <!-- Thinking Indicator -->
              <div v-if="isThinking" style="padding: 10px;">
                <h3
                  class="float-left thinking-bubble"
                  :style="(
                    'background:' + bot_details.widget_chat_bubble_left_color + '; color:' + (bot_details.widget_text_color || '#555555') + ';'
                    + ' border-radius:16px; font-size:14px; padding:10px; line-height:20px; margin:0; max-width:500px; white-space:normal; font-style: italic;'
                  )"
                >
                  Thinking<span class="dots"></span>
                </h3>
                <div style="clear: both;"></div>
              </div>
            </div>

            <div style="position: relative; box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.05); padding-top: 3px; border-radius: 0px 0px 5px 5px; padding-top: 14px;" :style="'height: ' + (($route.query.fl) ? '70px' :  '60px') + ';'">

                <div
                    style="position: absolute; right: 20px; top: 18px; background-color: rgb(58, 155, 219); border-color: rgb(58, 155, 219); color: #FFFFFF; padding: 11px; border-radius: 0px; cursor: pointer; border-radius: 4px; font-size: 12px;"

                    :style="((bot_details) ? 'background: ' + bot_details.widget_button_color : '')"

                    class="-mt-1"
                    fab
                    color="#3A9BDB"
                    dark
                    small
                    elevation="0"
                    @click="sendMessage(messageForm)"
                    >
                    <i class="mdi mdi-send"></i>
                </div>

                <div class="flex-shrink-1" style="padding-left: 20px;">
                    <input type="text"
                        class="mr-16 lf-inbox-new-message-field"
                        v-model="messageForm.content"
                        outlined
                        dense
                        style="background: rgba(25, 35, 58, 0.05); color: #757B89; border: 0px; padding: 8px; border: solid 1px #CCCCCC; border-radius: 4px; width: calc(100% - 73px); font-size: 14px;"
                        @keyup.enter="sendMessage(messageForm)"
                        :placeholder="'Type message...'"
                        hide-details
                    />

                    <div v-if="!isAccelerate() && bot_details.show_powered_by" style="font-size: 12px; padding-top: 7px;"><a :href="poweredByLink()">AI chat</a> {{ bot_details.powered_by_text || "powered by DIY AI" }}</div>
                </div>

                <div style="clear: both;"></div>
            </div>
        </div>
    </v-card>
  
  </template>
  
  <script>
  import { UltravoxSession } from 'ultravox-client';
  import { mapState } from 'vuex'
  import axios from 'axios'
  import moment from 'moment'
  
  export default {
        props: ['u', 'p'],

      data() {
          return {
              messages: [],
              threadLoaded: false,
              messages: [],
              messageForm: {
                  content: ""
              },
              sendingMessage: false,
              isThinking: false,
              lead_id: null,
              ai_enabled: null,
              gettingMessages: false,
              bot_details: {},

              firstMessageInitiated: false,

              // Lets Talk
              showPopover: false,
            phoneNumber: '',
            session: null,
            callActive: false,
            // ... other data properties
            prompt: '',
            ultravoxConnection: null,
            popoverStyle: {
                position: 'absolute',
                
            },
          }
      },
      methods: {
            formatContent(text) {
                if (!text) return '';

                // Escape HTML to avoid XSS
                const escapeHtml = (unsafe) => {
                return unsafe
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;");
                };

                // Auto-link URLs
                const autoLink = (str) => {
                const urlPattern = /((https?:\/\/|www\.)[^\s<]+)/g;
                return str.replace(urlPattern, (url) => {
                    let href = url;
                    if (!href.match(/^https?:\/\//)) {
                    href = 'http://' + href;
                    }
                    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
                });
                };

                // Replace newlines with <br>
                const nl2br = (str) => {
                return str.replace(/\n/g, "<br>");
                };

                const escaped = escapeHtml(text);
                const linked = autoLink(escaped);
                const formatted = nl2br(linked);

                return formatted;
            },

            isAccelerate() {
                return this.getHost() == 'lsa.accelerateyourmarketing.com';
                //  || this.getHost() == 'organic-train-7vqj4qq9x9hrgp5-8080.app.github.dev';
            },
            getHost() {
                return window.location.host;
            },
            poweredByLink() {
                return ((this.bot_details.powered_by_link) ? this.bot_details.powered_by_link : window.location.origin + "/signup");
            },
            getU() {
                return this.u || this.$route.query.u;
            },
            getP() {
                return this.p || this.$route.query.p;
            },
          calculateMessagesHeight() {
              if (this.$vuetify.breakpoint.xs)
                  return window.outerHeight - 185;
  
              return window.outerHeight - 300;
          },
  
          async getBotDetails(callback = null) {
              let response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/inbox/get-bot-data?u=' + this.getU() + '&p=' + this.getP(), {
                  headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  },
              })
  
              this.bot_details = response.data.bot_data;

              this.getResponse();

              this.getMessages();
          },

          async getMessages() {
          this.gettingMessages = true;
            
            if (this.lead_id) {
                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, {
                    lead_id: this.lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                if (!this.sendingMessage)
                    this.messages = response.data.transcription.messages;

                this.gettingMessages = false;
            }

            this.gettingMessages = false;

            let self = this;

            setTimeout(function() {
                self.getMessages();
            }, 5000);
          },
  
          async sendMessage() {
              if (!this.messageForm.content && !this.attached_image.src)
                  return;
              
              this.sendingMessage = true;

              this.messages.push({
                role: 'user',
                content: this.messageForm.content.toString(),
                timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss')
              });

              this.moveDown();

              this.messageForm.content = '';
  
              this.getResponse();
          },
  
          async getResponse() {
            var self = this;

            this.isThinking = true;

            await self.saveLead(false);

            var theTimeout = 1;

            if (self.getU() == "f52278ea-bf31-4eb2-82df-6d41063747c5") {
                theTimeout = 2000;
            }

            setTimeout(function() {
                executeMessage();
            }, theTimeout);

            async function executeMessage() {
                if (self.messages.length == 0) {
                    self.lead_id = null;
                }

                self.threadLoaded = true;

                if (self.ai_enabled !== 0) {
                    let response = await axios.post('https://ai.revulsab.com/get-response', {
                        messages: self.messages,
                        prompt: self.bot_details.prompt,
                        u: self.getU()
                    }, {
                        headers: {
                        'Authorization': 'Bearer ' + self.$store.state.auth.jwt
                        },
                    })
        
                    self.messages.push({
                        role: "assistant",
                        "content": response.data.message,
                        timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss')
                    });

                    self.firstMessageInitiated = true;
                    self.isThinking = false;

                    self.moveDown();
                }

                self.saveLead(true);
            }
          },

          moveDown() {
            setTimeout(function() {
                var objDiv = document.getElementById("lfp-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 10);

            setTimeout(function() {
                var objDiv = document.getElementById("lfp-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 100);

            setTimeout(function() {
                var objDiv = document.getElementById("lfp-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 500);

            setTimeout(function() {
                var objDiv = document.getElementById("lfp-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 1000);
          },
  
          formatDate: function(date) {
              return moment(String(date)).calendar();
          },

          async saveLead(stopSending) {
                let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/inbox/save-chat-lead', {
                    u: this.getU(),
                    lead_id: this.lead_id,
                    messages: this.messages
                }, {
                    headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    },
                })

                this.lead_id = response.data.lead_id;
                this.ai_enabled = response.data.ai_enabled;

                if (stopSending)
                    this.sendingMessage = false;
          },

          togglePopover() {
      this.showPopover = !this.showPopover;
      this.$nextTick(() => {
        if (this.showPopover) {
          this.setPopoverPosition();
          document.addEventListener('click', this.handleOutsideClick);
        } else {
          document.removeEventListener('click', this.handleOutsideClick);
        }
      });
    },
    setPopoverPosition() {
      const button = this.$refs.talkButtonWrapper;
      const popover = this.$refs.popover;
      if (button && popover) {
        const rect = button.getBoundingClientRect();
        this.popoverStyle.top = `${rect.bottom + window.scrollY + 8}px`;
        this.popoverStyle.left = `${rect.left + window.scrollX}px`;
      }
    },
    handleOutsideClick(e) {
      if (
        !this.$refs.popover.contains(e.target) &&
        !this.$refs.talkButtonWrapper.contains(e.target)
      ) {
        this.showPopover = false;
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    async callMe() {
        let self = this;
      if (!this.phoneNumber) return;
      try {
        let params = {};
        params.From = "+" + self.getP().trim();
        params.To = self.phoneNumber;
        params.call_prompt = self.bot_details.prompt;

        params.initialMessages = [];

        for (var i in this.messages) {
            params.initialMessages.push({
                role: ((this.messages[i].role == "assistant") ? "MESSAGE_ROLE_AGENT" : "MESSAGE_ROLE_USER"),
                text: this.messages[i].content
            });
        }

        await axios.post(`https://aiv2.revulsab.com/make-call`, params, {
            headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })
        
        this.$swal({
          title: "Call initiated!",
          text: "The call has been successfully initiated.",
          showCancelButton: false,
        });
        this.showPopover = false;
        this.phoneNumber = '';
      } catch (err) {
        console.error(err);
        alert('Failed to initiate call.');
      }
    },
    async startInBrowserCall() {
        let self = this;
      try {
        // Initialize a new session

        this.session = new UltravoxSession();

        let prompt = self.bot_details.prompt;
        
        let initialMessages = [];

        for (var i in this.messages) {
            initialMessages.push({
                role: ((this.messages[i].role == "assistant") ? "MESSAGE_ROLE_AGENT" : "MESSAGE_ROLE_USER"),
                text: this.messages[i].content
            });
        }
        
        var params = {
            firstSpeaker: 'FIRST_SPEAKER_AGENT',
            transcriptOptional: false,
            // model: self.bot_details.ultravox_model,
            // voice: self.bot_details.voice_ultravox,
            recordingEnabled: true,
            systemPrompt: prompt,
            initialMessages: initialMessages
        };
    
        params.firstSpeakerSettings = {
            agent: {
                uninterruptible: true
            }
        };
    
        var response = await axios.post(`https://aiv2.revulsab.com/create-call-joinurl`, params, {
            params: params
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        console.log('response.data.joinUrl', response.data.joinUrl)

        // Replace with your actual join URL obtained from your backend
        const joinUrl = response.data.joinUrl;

        // Join the call
        this.session.joinCall(joinUrl);

        // Set call as active
        this.callActive = true;

        // Optionally, add event listeners
        this.session.addEventListener('status', (event) => {
          console.log('Session status changed:', this.session.status);
        });

        this.session.addEventListener('transcripts', (event) => {
          console.log('Transcripts updated:', this.session.transcripts);
        });
      } catch (error) {
        console.error('Ultravox call failed:', error);
        alert('Could not start the call.');
      }
    },
    async endInBrowserCall() {
      if (this.session) {
        await this.session.leaveCall();
        this.session = null;
        this.callActive = false;
      }
    },
      },
      mounted() {
          this.getBotDetails();
      },
  
      beforeDestroy() {
          clearInterval(this.thread_interval);
          this.thread_interval = null
      },
  
      watch: {
      }
  }
  </script>
  
    <style scoped>
      .v-card__title {
          background: rgba(31, 36, 47, 0.07);
          border: 0px !important;
      }
  
      .v-card.v-sheet.theme--light {
          border: 0px !important;
      }
  
      .theme--light.v-btn {
          color: #757B89 !important;
      }
  
      .lfp-attached-image {
          position: absolute;
          background: #FFFFFF;
          position: absolute;
          right: 80px;
          bottom: 70px;
          z-index: 10;
          box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.05);
          padding: 20px;
      }
  
      .lfp-attached-image img {
          border: solid 1px #CCCCCC;
      }
  
      a.choose_template_link {
          position: absolute; margin-left: 18px; margin-top: 5px; font-size: 14px; color: rgb(58, 155, 219) !important; font-weight: bold; z-index: 2;
      }
  
      a.send_screenshot_link {
          position: absolute; left: 160px; margin-top: 5px; font-size: 14px; color: rgb(58, 155, 219) !important; font-weight: bold; z-index: 1;
      }
  
      a.send_image_link {
          position: absolute; left: 300px; margin-top: -9px; font-size: 14px; color: rgb(58, 155, 219) !important; font-weight: bold; z-index: 1;
      }
  
      @media screen and (max-width: 900px) {
          a.choose_template_link {
              font-size: 13px;
          }
  
          a.send_screenshot_link {
              font-size: 13px;
              left: 140px;
          }
  
          a.send_image_link {
              font-size: 13px;
              left: 260px;
          }
      }

      .popover {
            background: white;
            border: 1px solid #ccc;
            border-radius: 8px;
            padding: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            z-index: 1000;
            min-width: 240px;
            margin-left: -210px;
            margin-top: 48px;
        }
        .option {
            display: flex;
            flex-direction: column;
        }

        .call-status {
            background: #f0f9ff;
            padding: 10px;
            border: 1px solid #91d5ff;
            border-radius: 8px;
        }

        .dots::after {
          content: '...';
          display: inline-block;
          animation: blinkDots 1s steps(3, end) infinite;
          margin-left: 4px; /* small spacing */
        }

        @keyframes blinkDots {
          0%, 20% { content: ''; }
          40% { content: '.'; }
          60% { content: '..'; }
          80%, 100% { content: '...'; }
        }
  </style>